import React from "react"

const CarouselDots = ({ dots }) => {
  const DotItem = dots.find(dot => dot).type

  return (
    <ul className="slider-dots">
      {dots.map((dot, index) => (
        <DotItem
          key={`dot-${dot.key}`}
          data-index={dot.key}
          className={`slider-dot ${dot.props.className}`}
          onClick={dot.props.children.props.onClick}
					tabIndex={0}
					aria-label={`go to slide ${index + 1} of ${dots.length}`}
        >
          <span>
            <span></span>
          </span>
        </DotItem>
      ))}
    </ul>
  )
}

export default CarouselDots
